// ANGULAR DEPENDANCY
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

// EXTERNAL DEPENDANCY
import { Observable } from 'rxjs';

// SERVICES
import { ApiConfigService } from '../../core/services/api-config/api-config.service';
import { BaseService } from '../../core/services/base/base.service';
import { TokenStorageService } from '../../core/services/token-storage/token-storage.service';

// COMMON INTERFACES
import { ApiPayload } from '../../../models/common/api/api-payload.interface';
import { ApiResponse } from '../../../models/common/api/api-response.interface';

// CONSTANTS
import { APIUtil } from '../../../../app/core/utils/api-util';
import { MASTER_API_URL } from '../../../constants/api';

/**
 * This service is for get and shared master data
 * For get master variables
 *
 * @author Pratik Shihora <pratik@saeculumsolutions.com>
 *
 * Notes:-
 * Date: 16/03/2020 (Pratik Shihora <pratik@saeculumsolutions.com>) initially created master service
 */
@Injectable()
export class MasterService extends BaseService {

  constructor(
    protected httpClient: HttpClient,
    protected tokenStorage: TokenStorageService,
    public apiConfig: ApiConfigService) {
    super(httpClient, tokenStorage);
  }

  /**
	 * Get master country list
	 * @param payload : Api common payload object
	 * @returns Observable<ApiResponse>
	 */
  public getCountryList(payload: ApiPayload): Observable<ApiResponse> {
    const url = `${this.apiConfig.getApiUrl()}${MASTER_API_URL.COUNTRY}`;

    return this.get(url);
  }
  /**
  * Get master countrycode list
  * @param payload : Api common payload object
  * @returns Observable<ApiResponse>
  */
  public getCountryCodeList(payload: ApiPayload): Observable<ApiResponse> {
    const url = `${this.apiConfig.getApiUrl()}${MASTER_API_URL.COUNTRY_CODE}`;

    return this.get(url);
  }
  /**
  * Get master State list
  * @param payload : Api common payload object
  * @returns Observable<ApiResponse>
  */
  public getStateList(payload: ApiPayload): Observable<ApiResponse> {
    const replaceParams = ['country_id'];
    const url = APIUtil.getAppendParams(this.apiConfig.getApiUrl() + MASTER_API_URL.STATE, replaceParams, payload.data);

    return this.get(url);
  }

  /**
  * Get master State list
  * @param payload : Api common payload object
  * @returns Observable<ApiResponse>
  */
  public getAllStateList(payload: ApiPayload): Observable<ApiResponse> {
    const url = `${this.apiConfig.getApiUrl()}${MASTER_API_URL.ALL_STATE}`;

    return this.get(url);
  }

  /**
  * Get master Timezone list
  * @param payload : Api common payload object
  * @returns Observable<ApiResponse>
  */
  public getTimeZoneList(payload: ApiPayload): Observable<ApiResponse> {
    const url = `${this.apiConfig.getApiUrl()}${MASTER_API_URL.TIMEZONE}`;

    return this.get(url);
  }

  /**
  * Get currency Lookup
  * @param payload : Api common payload object
  * @returns Observable<ApiResponse>
  */
 public getCurrencyLookup(payload: ApiPayload): Observable<ApiResponse> {
  const url = `${this.apiConfig.getApiUrl()}${MASTER_API_URL.CURRENCY_LOOKUP}`;

  return this.get(url);
}

  /**
    * Get master TrainingLicensce list
    * @param payload : Api common payload object
    * @returns Observable<ApiResponse>
    */
  public getTrainingLicensceList(payload: ApiPayload): Observable<ApiResponse> {
    const url = `${this.apiConfig.getApiUrl()}${MASTER_API_URL.TRAINING_LICENCE}`;

    return this.get(url);
  }

  /**
   * Get master Areataskgroup list
   * @param payload : Api common payload object
   * @returns Observable<ApiResponse>
   */
  public getAreaTaskGroupAreaList(payload: ApiPayload): Observable<ApiResponse> {
    const url = `${this.apiConfig.getApiUrl()}${MASTER_API_URL.TASK_GROUP_AREA}`;

    return this.get(url);
  }

  /**
    * Get master Location Taskgroup list
    * @param payload : Api common payload object
    * @returns Observable<ApiResponse>
    */
  public getLocationTaskGroupList(payload: ApiPayload): Observable<ApiResponse> {
    const url = `${this.apiConfig.getApiUrl()}${MASTER_API_URL.TASK_GROUP_LOCATION}`;

    return this.get(url);
  }
}
